<template>
  <div>
    <el-popover
      placement="top"
      trigger="hover"
      v-bind="attribute"
    >
      <shadow-dom :content="content()"></shadow-dom>
      <shadow-dom
        slot="reference"
        :content="content()"
      ></shadow-dom>
    </el-popover>
  </div>
</template>

<script>
import shadowDom from '@/components/shadowDom/shadowDom.vue';
export default {
	props: ['scope', 'tableData'],
	data() {
		return {};
	},
	computed: {
		attribute() {
			let { tableData } = this;
			return (tableData && tableData.attribute) || {};
		},
	},
	methods: {
		content() {
			let { scope, tableData } = this;
			if (typeof tableData.content === 'function') {
				return tableData.content(scope.row);
			}
			return scope.row[tableData.bind] || '-';
		},
	},
	components: {
		shadowDom,
	},
};
</script>

<style>
</style>
